import { CrmUser } from "./api";

export const fetchUserProfile = async (authToken: string): Promise<CrmUser> => {
    const localUrl = new URL(location.origin + "/api/fpp/user-profile");
    const method = "GET";
    const response = await fetch(localUrl, {
        method,
        headers: { Authorization: "Bearer " + authToken },
    });

    return response.ok
        ? response.json()
        : Promise.reject(new Error(`Failed to fetch user profile: ${response.status} ${response.statusText}`));
};
